var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"container"},[_c('router-view')],1),(_vm.isProcessing)?_c('ScreenGuard'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }